import { render, staticRenderFns } from "./WaybillEdit.vue?vue&type=template&id=7844428a&scoped=true&"
import script from "./WaybillEdit.vue?vue&type=script&lang=js&"
export * from "./WaybillEdit.vue?vue&type=script&lang=js&"
import style0 from "./WaybillEdit.vue?vue&type=style&index=0&id=7844428a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7844428a",
  null
  
)

export default component.exports